export default "__VITE_ASSET__Cq$ZDKjx__"